import type { JSX } from 'react';

import { Box, Flex } from '@change-corgi/design-system/layout';

import { SetPageStateValue } from 'src/shared/pageState';

import { useFocusFallbackRef } from 'src/app/shared/hooks/focus';
import { useIsStarter } from 'src/app/shared/hooks/session';

import { RedirectUnauthorized } from '../components/RedirectUnauthorized';
import { StepBody } from '../components/StepBody';
import { StepProgressBar } from '../components/StepProgressBar';

import { useTrackLoginOrJoinMethod } from './hooks/useTrackLoginOrJoinMethod';
import { useTrackSapView } from './hooks/useTrackSapView';

export function StartAPetitionLayout(): JSX.Element {
	useTrackLoginOrJoinMethod();
	useTrackSapView();
	const isStarter = useIsStarter();

	const ref = useFocusFallbackRef(
		({ container, focus }) =>
			focus(container.querySelector('#prepublish-container')) || focus(container.querySelector('h1')),
	);

	return (
		// Height is calculated by subtracting the heading height from 100vh.
		// This allows the page content to fill the	full height
		// for elements that have a solid background color
		<Flex sx={{ height: ['calc(100vh - 48px)', 'calc(100vh - 58px)'], flexDirection: 'column' }} ref={ref}>
			<RedirectUnauthorized />
			<SetPageStateValue name="sapPageState" value={{ isStarter }} />
			<StepProgressBar />
			<StepBody />
			{/* This component preserves the space for the mobile navigation button so that other
			components would not be presented behind the fixed navigation buttons on the bottom of the screen. */}
			<Box sx={{ display: ['block', 'none'], minHeight: 77 }} />
		</Flex>
	);
}
